import { observable, runInAction, computed } from 'mobx';
import { get } from '../utils';

class FloorList {
    private route: string;
    private params: any;

    @observable
    private floorListData: any = [];

    constructor(params: any) {
        this.route = params.url;
        this.params = params;
    }

    async fetch(callback?, errs?) {
        let obj = Object.assign(this.params);
        get(this.route, obj).then((d) => {
            let data;
            if (d.data) {
                data = d.data;
                runInAction(() => {
                    this.floorListData = data;
                    callback && callback(data);
                });
            } else {
                callback && callback([]);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    @computed
    get list() {
        return this.floorListData.slice();
    }
}

export default FloorList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/FloorList.ts